import { create } from 'zustand';

// Hide/report modal state lives OUTSIDE the bonus card subtree on purpose:
// the optimistic hidden-ids cache update unmounts the card on the very next
// render, so any modal state owned by the card dies before it can paint. The
// menu writes here; GlobalBonusCompletionModals (mounted in global-modals.tsx)
// reads here and renders above the filtered feed.
//
// The hide flow walks hide-confirm → (mutation pending) → hide-complete in a
// single modal so the user gets a chance to consider before anything fires.

type CompletionModalKind = 'hide-confirm' | 'hide-complete' | 'report-complete';

interface BonusCompletionModalsStore {
	openModal: CompletionModalKind | null;
	// captured at confirm-open time: the card (and its bonus prop) may be gone
	// by the time the user clicks confirm, so the host needs its own copy
	hideBonusId: string | null;
	openHideConfirm: (bonusId: string) => void;
	openHideCompletion: () => void;
	openReportCompletion: () => void;
	onClose: () => void;
}

export const useBonusCompletionModalsStore = create<BonusCompletionModalsStore>((set) => ({
	openModal: null,
	hideBonusId: null,
	openHideConfirm: (bonusId) => set({ openModal: 'hide-confirm', hideBonusId: bonusId }),
	openHideCompletion: () => set({ openModal: 'hide-complete', hideBonusId: null }),
	openReportCompletion: () => set({ openModal: 'report-complete' }),
	onClose: () => set({ openModal: null, hideBonusId: null }),
}));
